import { useInvoiceComplianceMode } from '@features/invoices/hooks/useInvoiceComplianceMode'

import { EInvoiceDetailsCard } from './elements/EInvoiceDetailsCard'
import { InvoiceDetailsCard } from './elements/InvoiceDetailsCard'
import { InvoiceTimelineStatus } from './elements/InvoiceTimelineStatus'
import * as Styled from './styles'

export const InvoiceViewSidebar = () => {
  const { isFrenchComplianceMode } = useInvoiceComplianceMode()

  return (
    <Styled.InvoiceViewSidebarWrapper>
      <InvoiceDetailsCard />
      {isFrenchComplianceMode && <EInvoiceDetailsCard />}
      <InvoiceTimelineStatus />
    </Styled.InvoiceViewSidebarWrapper>
  )
}
